import Big from 'big.js'
import { DECIMALS_LSD } from 'config'

import { separateNumber } from './separateNumber'

export const formatCountLSD = (count: string, separate?: number) => {
  const decimals = new Big(10).pow(DECIMALS_LSD).toString()
  const formatCount = new Big(count).div(decimals).toString()
  const [integerPart] = formatCount.split('.')

  if (Number(integerPart) > 0) {
    return separateNumber(integerPart, separate)
  }

  return formatCount
}
